export enum AmountCondition {
    Money = `money`,
    Points = `points`,
}

export enum ContentCondition {
    Every = `every`,
    Any = `any`,
}
